const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Asignar tipos de prenda a un edificio
 */
export const assignGarmentTypesToEdificio = async (edificioId, garmentTypeIds) => {
  try {
    const response = await fetch(`${API_URL}/edificios/assign-garment-types`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        edificioId,
        garmentTypeIds,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Error al asignar tipos de prenda');
    }

    return data;
  } catch (error) {
    console.error('Error en assignGarmentTypesToEdificio:', error);
    throw error;
  }
};

/**
 * Obtener tipos de prenda asignados a un edificio
 */
export const getEdificioGarmentTypes = async (edificioId) => {
  try {
    const response = await fetch(`${API_URL}/edificios/${edificioId}/garment-types`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Error al obtener tipos de prenda');
    }

    return data;
  } catch (error) {
    console.error('Error en getEdificioGarmentTypes:', error);
    throw error;
  }
};
